// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".avatar[data-v-513a91bc]{margin:auto;width:16rem}.logo[data-v-513a91bc]{min-height:100px}.background-image[data-v-513a91bc]{flex-shrink:0;background-position:50%;background-repeat:no-repeat;background-size:cover}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
